import React from 'react'
import { useEstadosContrato } from '../../contexts/EstadosContratoContext';
import { AuthContext } from '../../auth/authContext';
import { FormControl, InputLabel, NativeSelect } from '@mui/material';
import { LoadingComponent } from '../LoadingComponent/LoadingComponent';
import { postCambiarEstadoDeUnContrato } from '../../API/ApiEstadosDeContrato';
import { toast } from 'react-toastify';
import { checkPermisosPorUsuarioPorGuidPantalla } from '../../API/ApiPermisos';
const guidVista = "6ac593c2-4810-4081-bb29-e80830750a85";

const CambiarStatusDeContratoPrevisionComponent = (props) => {
    const { user, dispatch } = React.useContext(AuthContext);
    const { estadosContrato } = useEstadosContrato();
    const [loading, setLoading] = React.useState(false);
    const [statusActual, setStatusActual] = React.useState(props.finalData.etapaUno[0].idestadoContrato);

    const [checkPersmissions, setCheckPermissions] = React.useState([]);
    const [permisoParaEditar, setPermisoParaEditar] =
        React.useState(false);

    React.useEffect(() => {
        checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
            (resultado) => {
                if (resultado.status == 200) {



                    
                    setCheckPermissions(resultado.data);
                    for (const permiso of resultado.data) {
                        if (
                            (permiso.guidFuncion == "fcf3d0e9-eaa3-40f4-be2b-bef8ba2e984c" || permiso.guidFuncion == "f67a558b-c70c-4b34-b958-f3da063db2fc") &&
                            permiso.allowed == 1
                        ) {
                            setPermisoParaEditar(true);
                        }
                    }
                }
            }
        );
    }, []);

    const handleCancelarContrato = (event) => {
        const nuevoStatus = event.target.value;
        setStatusActual(nuevoStatus);
        // Aquí puedes hacer otras acciones con el nuevoStatus
    };

    const handleActualizarCampo = () => {

        setLoading(true);
        
        postCambiarEstadoDeUnContrato(user, { idcontrato: props.finalData.etapaUno[0].id, idestadoContrato: statusActual }).then((resultado) => {
            
            if (resultado && resultado.status === 200) {
                toast.success("Estado del contrato actualizado correctamente");
            }

        }).finally(() => {
            setLoading(false);
        })

        // Aquí va la lógica para actualizar el campo con el valor de statusActual
        // Ejemplo: console.log('Actualizar campo:', statusActual);
    };

    return (
        <React.Fragment>

            {loading && <LoadingComponent />}
            <div className='container-fluid'>
                <div className=' row'>
                    <div className=' col-md-6'>
                        <div className="d-flex align-items-end gap-2 mt-5 mb-5">
                            <FormControl fullWidth>
                                <InputLabel
                                    variant="standard"
                                    htmlFor="uncontrolled-native"
                                    shrink={true}
                                >
                                    Status Contrato
                                </InputLabel>
                                <NativeSelect
                                    value={statusActual}
                                    onChange={handleCancelarContrato}
                                    disabled={permisoParaEditar ? false : true}
                                    inputProps={{
                                        name: "status",
                                        id: "uncontrolled-native",
                                    }}
                                >
                                    {estadosContrato.map(estado => (
                                        <option key={estado.id} value={estado.id}>{estado.estadoContrato}</option>
                                    ))}
                                </NativeSelect>
                            </FormControl>

                            {
                                permisoParaEditar && <button onClick={handleActualizarCampo} className=' btn btn-success'>
                                    Actualizar estado
                                </button>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CambiarStatusDeContratoPrevisionComponent
